














import { Vue, Component } from 'vue-property-decorator';
import { Cell } from 'vant';
Vue.use(Cell);
@Component
export default class ActivityList extends Vue {
  list = require('../../../../db/routes.json');
  created() {
    console.log(this.list);
  }
}
